import {_request, _requestForm} from "./api";

export const list = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'federation/all', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
